export const API_URL = 'https://apiv1.test-campestre.teko-dev.com/api/';
export const DOCUMENTS_URL = 'https://apiv2.test-campestre.teko-dev.com/';
export const NEW_API_URL = 'https://apiv2.test-campestre.teko-dev.com/api/';
export const CAMPESTRE_API = 'https://campestreags.com/wp-json/';
export const MQTT_HOST = "wss://campestreags.com/wss-mqtt"
export const MQTT_USERNAME = "TekoMQ"
export const MQTT_PASSWORD = "TekoMQ22.*"
